import { useEffect, useState } from "react";
import IAvatarProps from "./IAvatarProps";
import styles from "./Avatar.module.scss";

export const Avatar = (props: IAvatarProps) => {
    const { name, src, alt, size } = props;

    const [failedToLoad, setFailedToLoad] = useState<boolean>(false);

    useEffect(() => {
        setFailedToLoad(false);
    }, [src]);

    const initials = getInitials(name);

    if (src && !failedToLoad) {
        return (
            <img
                className={`${styles.avatar} ${styles.image} ${styles[size]}`}
                src={src}
                alt={alt ?? name}
                onError={() => setFailedToLoad(true)}
            />
        );
    }

    return (
        <span className={`${styles.avatar} ${styles.initials} ${styles[size]}`} aria-label={alt ?? name}>
            {initials}
        </span>
    );
};

const getInitials = (name: string) => {
    const parts = name.trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) {
        return "?";
    }

    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
    }

    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};
